import React from "react";
import { FaBars, FaUserCircle } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";

const DrivingSchoolHeader = ({ pageTitle, breadcrumbs, onMenuClick }) => {
  const { user } = useAuth();

  return (
    <div className="bg-white border-bottom px-3 px-md-4 py-3 d-flex justify-content-between align-items-center dashboard-topbar">
      
      {/* LEFT */}
      <div className="d-flex align-items-center gap-2 gap-md-3 dashboard-topbar-left">
        
        {/* MOBILE MENU ICON */}
        <button
          className="btn btn-light d-lg-none"
          onClick={onMenuClick}
        >
          <FaBars />
        </button>

        <div className="min-w-0">
          <h6 className="mb-1 fw-bold text-truncate">{pageTitle}</h6>
          <div className="text-muted small dashboard-breadcrumbs">
            {breadcrumbs.map((b, i) => (
              <span key={i}>
                {i !== 0 && " / "}
                {b.label}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* RIGHT */}
      <div className="d-flex align-items-center gap-2 gap-md-3 dashboard-topbar-right">
        <div className="text-end d-none d-md-block">
          <div className="fw-semibold">{user?.name}</div>
          <small className="text-muted">{user?.username}</small>
        </div>
        <FaUserCircle size={32} />
      </div>
    </div>
  );
};

export default DrivingSchoolHeader;
